<p-card [header]="header">
  <editor [init]="initProps" [(ngModel)]="content"></editor>
  <hr>
  <p-footer>
    <div class="bottom-buttons">
      <button pButton type="button" icon="pi pi-check" (click)="onSubmit()" label="Сохранить" class="p-button-success"
        style="margin-right: .5em"></button>
      <button pButton type="button" icon="pi pi-ban" (click)="onCancel()" label="Отмена"
        class="p-button-secondary"></button>
    </div>
  </p-footer>
</p-card>
